export function hasOwn<T extends object, K extends PropertyKey>(
  obj: T,
  key: K
): key is K & keyof T {
  return Object.hasOwn(obj, key);
}
